class TMv_ExpandedInset {

	element;
	button;
	options = {
		transition_speed : 800, // milliseconds

	};
	constructor(element, params) {
		this.element = element;
		Object.assign(this.options, params);

		this.button = this.element.querySelector('.expansion_button');
		this.button.addEventListener('click', this.toggleShowing.bind(this));
	}

	/**
	 * Toggles the showing of the item
	 * @param {Event} event
	 */
	toggleShowing(event) {
		// No action
		event.preventDefault();


		let button_container = this.button.parentElement;
		let section = this.button.closest('section.pages_layout');

		if(section.classList.contains('showing'))
		{
			// switch to HIDING
			button_container.classList.add('text_mode');
			button_container.classList.remove('arrow_mode');
			section.querySelectorAll('.row.TMv_ContentLayout').forEach(row => {
				row.slideUp(this.options.transition_speed);
				section.classList.remove('showing');
				section.classList.add('hiding');
			});
		}
		else
		{
			// switch to SHOWING
			button_container.classList.add('arrow_mode');
			button_container.classList.remove('text_mode');
			section.querySelectorAll('.row.TMv_ContentLayout').forEach(row => {
				row.slideDown(this.options.transition_speed);
				section.classList.add('showing');
				section.classList.remove('hiding');
			});

		}

	}
}